import React, { useState, useEffect } from 'react';
import { Typography, Input, Button, Cascader, Dropdown, Menu, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import styles from './SearchBar.module.scss';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { setSearchValue, setClassificationText } from '@/store/slices/searchBarSlice';
import { getProductCategoryAllList } from '@/api/products';
import SearchConponent from '../SearchConponent/SearchConponent';
import { useNavigate, useLocation } from 'react-router-dom';
interface HomeChildProps {
  // children: React.ReactNode;
  // getMessage?: (str: string) => void; // 可选的回调函数
}

interface CascaderOption {
  value: number;
  label: string;
  children?: CascaderOption[];
  isLeaf?: boolean;
}

interface IClassification {
  is_active: boolean;
  is_delete: boolean;
  order: any;
  parent_id: number;
  product_category_id: number;
  product_category_name: string;
  child?: IClassification[];
}

const SearchBar: React.FC<HomeChildProps> = ({ }) => {
  const dispatch = useAppDispatch();
  const classificationText = useAppSelector((state) => state.searchBar.classificationText);

  const navigate = useNavigate();

  

  // 获取当前路径信息
  const location = useLocation();

  //级联选项
  const [cascaderOptions, setCascaderOptions] = useState<CascaderOption[]>([]);
  //默认值
  const [defaultCascaderValue, setDefaultCascaderValue] = useState<number[]>([]);
  //选中值
  const [selectedCascaderValue, setSelectedCascaderValue] = useState<number[]>([]);

  // 将原始分类数据转换为Cascader需要的格式
  const transformToCascaderOptions = (data: IClassification[] = []): CascaderOption[] => {
    return data.map(item => {
      const hasChildren = item.child && item.child.length > 0;
      return {
        value: item.product_category_id,
        label: item.product_category_name,
        children: hasChildren ? transformToChildrenOptions(item.child) : undefined,
        isLeaf: !hasChildren // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 转换子分类数据
  const transformToChildrenOptions = (children: IClassification[] = []): CascaderOption[] => {
    return children.map(child => {
      const hasChildren = child.child && child.child.length > 0;
      return {
        value: child.product_category_id,
        label: child.product_category_name,
        children: hasChildren ? transformToChildrenOptions(child.child) : undefined,
        isLeaf: !hasChildren // 如果没有子分类，则标记为叶子节点
      };
    });
  };

  // 查找第一条数据的最后一个节点
  const findLastNodePath = (data: IClassification[]): number[] => {
    if (!data || data.length === 0) return [];

    const path: number[] = [];
    let currentNode = data[0]; // 第一条数据
    path.push(currentNode.product_category_id);

    // 递归查找最深的子节点
    while (currentNode.child && currentNode.child.length > 0) {
      currentNode = currentNode.child[0];
      path.push(currentNode.product_category_id);
    }

    return path;
  };

  // 根据ID查找完整路径
  const findPathById = (options: CascaderOption[], targetId: number, currentPath: number[] = []): number[] | null => {
    for (const option of options) {
      // 尝试当前路径
      const newPath = [...currentPath, option.value];

      // 如果找到目标ID
      if (option.value === targetId) {
        return newPath;
      }

      // 如果有子节点，递归查找
      if (option.children && option.children.length > 0) {
        const result = findPathById(option.children, targetId, newPath);
        if (result) {
          return result;
        }
      }
    }

    return null;
  };

  // 查找选中ID的完整路径
  useEffect(() => {
    if (classificationText.product_category_id && cascaderOptions.length > 0) {

      const path = findPathById(cascaderOptions, classificationText.product_category_id);
      if (path) {
        setSelectedCascaderValue(path);
      }
    }
  }, [classificationText.product_category_id, cascaderOptions]);

  //获取分类数据
  useEffect(() => {
    getProductCategoryAllList().then((res) => {
      //console.log(res, 'getProductCategoryAllList');
      if (res.code === 200) {
        const data = res.data || [];
        //格式化分类数据
        const options = transformToCascaderOptions(data);
        setCascaderOptions(options);

        // 查找第一条数据的最后一个节点路径
        const lastNodePath = findLastNodePath(data);
        if (lastNodePath.length > 0) {
          setDefaultCascaderValue(lastNodePath);

          // 如果有最后一个节点，设置为默认选中值
          if (lastNodePath.length > 0) {
            const lastNodeId = lastNodePath[lastNodePath.length - 1];

            // 递归查找节点的名称
            const findNodeName = (nodes: IClassification[], id: number): string => {
              for (const node of nodes) {
                if (node.product_category_id === id) {
                  return node.product_category_name;
                }
                if (node.child && node.child.length > 0) {
                  const name = findNodeName(node.child, id);
                  if (name) return name;
                }
              }
              return '';
            };

            const lastNodeName = findNodeName(data, lastNodeId);

            // // 设置默认值
            // dispatch(setClassificationText({
            //   product_category_id: lastNodeId,
            //   product_category_name: lastNodeName,
            // }));
          }
        }
      }
    });


  }, [dispatch]);

  //搜索回调
  const getMessage = (inputValue: string): void => {
    // dispatch(setSearchValue(inputValue));
    if (location.pathname === '/') {
      navigate(`/searchList?keyword=${inputValue}`);
    } else if(location.pathname === '/liveNow') {
      console.log('liveNow',inputValue);
    }

  }


  // 处理分类选择
  const handleCascaderChange = (value: any, selectedOptions: any): void => {
    console.log(value, 'value');
    console.log(selectedOptions, 'selectedOptions');

    if (selectedOptions && selectedOptions.length > 0) {
      const lastOption = selectedOptions[selectedOptions.length - 1];
      // 只有当选择的是叶子节点时才设置值
      if (lastOption.isLeaf) {


        // dispatch(setClassificationText({
        //   product_category_id: lastOption.value,
        //   product_category_name: lastOption.label,
        // }));

        navigate(`/searchList?product_category_id=${value}`);


        // 保存完整路径
        setSelectedCascaderValue(value);
      }
    }
  };

  // 显示分类路径
  const displayRender = (labels: string[]): string => {
    return labels.join(' > ');
  };



  return (
    <div className={styles['search-bar']}>

      <div className={styles['search-bar-content']}>
        
        {/* <div className={styles['search-Classification']}>
          <div className={styles['Classification-text']}>
            <Cascader

              defaultValue={defaultCascaderValue.length > 0 ? defaultCascaderValue : undefined}
              value={selectedCascaderValue.length > 0 ? selectedCascaderValue : undefined}
              options={cascaderOptions}
              expandTrigger="hover"
              displayRender={displayRender}
              onChange={handleCascaderChange}
              placeholder="Select a category"
              className={styles['cascader-selector']}
              changeOnSelect={false}
              // 只允许选择叶子节点
              fieldNames={{ label: 'label', value: 'value', children: 'children' }}
              showSearch={{
                filter: (inputValue, path) =>
                  path.some(option =>
                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                  ),
                matchInputWidth: true,
                limit: 10, // 限制最多展示多少个匹配项（可选）
              }}
            />

          </div>
        </div> */}

        <SearchConponent getMessage={getMessage} />
        

      </div>


    </div>
  );
};

export default SearchBar; 